import React, { Component } from 'react'
import { Select, Input } from '@driftt/tide-core-legacy'
import { api } from 'app/modules/sfdc/api'

import './style.styl'

const MISSING_CAMPAIGN = 'The previously used campaign is no longer available.'
const UNKNOWN_ERROR = 'An unknown error occurred. If this problem persists, please chat with us.'
const SEARCH_DEBOUNCE_TIMEOUT = 500


class SalesforcePlaybookCampaignSelect extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: true,
            hasError: false,
            onlyNetNew: false,
            selectValue: null,
            selectLabel: null,
            selectOptions: [],
            responseOptions: [],
        }
    }

    componentDidMount() {
        this.fetchSalesforceOptions()
    }

    fetchSalesforceOptions = async () => {
        try {
            const selectOptions = []
            let hasSelectValue = false

            const [
                { salesforceCampaigns },
                { salesforceCampaignId, salesforceCampaignName, toggle },
            ] = await Promise.all([
                api.getSalesforceCampaigns(),
                api.getSelectedSalesforceCampaign(this.props.playbookId)
            ])

            salesforceCampaigns.forEach(campaign => {
                if (campaign.Id === salesforceCampaignId) {
                    hasSelectValue = true
                }

                selectOptions.push({
                    label: campaign.Name,
                    value: campaign.Id
                })
            })

            if (!hasSelectValue && !!salesforceCampaignId) {
                selectOptions.unshift({
                    label: salesforceCampaignName,
                    value: salesforceCampaignId
                })
            }

            this.setState({
                selectValue: salesforceCampaignId,
                selectLabel: salesforceCampaignName,
                onlyNetNew: !!toggle,
                selectOptions,
                isLoading: false
            })
        } catch(err) {
            console.warn(err)
            this.handleUnknownError()
        }
    }

    handleMissingCampaign = () => {
        this.setState({
            isLoading: false,
            hasError: true,
            selectValue: null,
            errorText: MISSING_CAMPAIGN
        })
    }

    handleUnknownError = () => {
        this.setState({
            isLoading: false,
            hasError: true,
            errorText: UNKNOWN_ERROR
        })
    }
    onDone = () => {
        this.setState({ isLoading: false })
    }

    onChange = (campaign) => {
        const onStateSet = () => {
            if (!!this.state.selectValue) {
                api.setSalesforceCampaign({
                    salesforceCampaignId: campaign.value,
                    playbookId: this.props.playbookId,
                    toggle: this.state.onlyNetNew,
                })
            }
            else {
                api.deleteSalesforceCampaign(this.props.playbookId)
            }
        }
        if (!!campaign.value) {
            this.setState({
                selectValue: campaign.value,
                selectLabel: campaign.label
            }, onStateSet)
        }
        else {
            this.setState({
                selectValue: null,
                selectLabel: null,
                onlyNetNew: false
            }, onStateSet)
        }
    }

    searchSalesforceCampaigns = (query) => {
        //we limit SF response to 500 for rendering purposes.
        //We then need to consult with SF incase a campaign is not in the 500 returned
        if (this.state.selectOptions.length < 500) {
            this.setState({ responseOptions: [] })
            return;
        }
        if (query.length <= 2 && !this.state.selectValue) {
            this.setState({ responseOptions: [] })
            return;
        }
        // salesforce wants queries of length > 2 or it won't return anything
        if (query.length > 2) {
            this.debouncedSearch(query)
        }
        return query
    }

    searchForCampaigns = async (query) => {
        const onDone = (response) => {
            const responseOptions = response.salesforceCampaigns.map(
                campaign => ({
                    label: campaign.Name,
                    value: campaign.Id
                })
            )

            this.setState({
                responseOptions,
                isLoading: false
            })
        }
        this.setState({ isLoading: true })
        try {
            await api.fetchCampaigns(query).then(onDone)
        }
        catch (e) {
            console.log(e)
            this.handleUnknownError()
        }
    }

    debouncedSearch = _.debounce(this.searchForCampaigns, SEARCH_DEBOUNCE_TIMEOUT)

    resolveDefaultSelectOption = () => {
        const { defaultSelectLabelText } = this.props
        return { value: null, label: defaultSelectLabelText }
    }

    resolveSelectOptions = () => {
        const { selectOptions } = this.state
        const defaultSelectOption = this.resolveDefaultSelectOption()
        return selectOptions.concat(defaultSelectOption)
    }

    updateOnlyNetNew = () => {
        api.setSalesforceCampaign({
            salesforceCampaignId: this.state.selectValue,
            playbookId: this.props.playbookId,
            toggle: !this.state.onlyNetNew,
        })

        this.setState({
            onlyNetNew: !this.state.onlyNetNew
        })
    }

    render() {

        const { description, defaultSelectLabelText } = this.props
        const { selectValue, isLoading, hasError, errorText, onlyNetNew, responseOptions } = this.state
        const defaultSelectOption = this.resolveDefaultSelectOption()
        const selectOptions = responseOptions.length > 0 ? responseOptions : this.state.selectOptions

        return (
            <div className="salesforce-playbook-campaign-select-container">
                <div className="advanced-integration-toggle-header">
                    <div className="salesforce-campaign-select-title">Salesforce Campaign</div>
                    <div className="salesforce-playbook-campaign-select-description">
                        {description}
                    </div>
                </div>
                <div>
                    <Select
                        className="salesforce-campaign-select-input"
                        autosize={false}
                        placeholder={defaultSelectLabelText}
                        value={selectValue}
                        options={selectOptions}
                        isLoading={isLoading}
                        onChange={this.onChange}
                        resetValue={defaultSelectOption}
                        onInputChange={this.searchSalesforceCampaigns}
                    />
                    {hasError &&
                        <p className="salesforce-campaign-error-text">
                            {errorText}
                        </p>
                    }
                    <div className="salesforce-campaign-checkbox">
                        <Input className="salesforce-campaign-input" type="checkbox" checked={onlyNetNew} onChange={this.updateOnlyNetNew}></Input>
                        <p className="salesforce-campaign-paragraph">Only associate net new leads/contacts with this campaign</p>
                    </div>
                </div>
            </div>)
    }
}

export default SalesforcePlaybookCampaignSelect



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SalesforcePlaybookCampaignSelect/index.js